import {
  arrayEqual,
  Equal,
  objectEqual,
  stringEqual,
} from "@redotech/util/equal";
import * as z from "zod";
import {
  productAsVariantStrategyEqual,
  ProductAsVariantStrategySchema,
} from "./product-as-variant-strategy";

export const productsAsVariantsConfigurationEqual: Equal<ProductsAsVariantsConfiguration> =
  objectEqual<ProductsAsVariantsConfiguration>({
    collectionId: stringEqual,
    strategies: arrayEqual(productAsVariantStrategyEqual),
  });

export const ProductsAsVariantsConfigurationSchema = z.object({
  collectionId: z.string(),
  strategies: z.array(ProductAsVariantStrategySchema),
  createdAt: z.string().optional(),
  lastSyncedAt: z.string().nullish(),
});
export type ProductsAsVariantsConfiguration = z.infer<
  typeof ProductsAsVariantsConfigurationSchema
>;
